// Card copy follows the same language as the field labels (`lng` from Redux),
// not i18next. i18next loads a cacheable JSON file in the background, so a
// newly added key can stay in English on an otherwise Arabic page.

const COPY = {
  ar: {
    listen: "استمع إلى العينات",
    samples: "عينات",
    voiceSamples: "العينات الصوتية",
    close: "إغلاق",
    noSamples: "لا توجد عينات مضافة بعد.",
  },
  en: {
    listen: "Listen to samples",
    samples: "samples",
    voiceSamples: "Voice Samples",
    close: "Close",
    noSamples: "No samples added yet.",
  },
};

export const cardCopy = (lng) => COPY[lng === "en" ? "en" : "ar"];

export const samplesCountLabel = (count, lng) => {
  const { samples } = cardCopy(lng);
  return `${count} ${samples}`;
};
